import { render } from "./DefaultAvatar.vue?vue&type=template&id=8dce9364&scoped=true"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js"

import "./DefaultAvatar.vue?vue&type=style&index=0&id=8dce9364&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dce9364"]])

export default __exports__